import React from "react";
import { IGalleryImageData } from "../../exports/interfaces";
import { Link } from "react-router-dom";
import { formatDateDetails } from "../../exports/functions";
import { useLoader } from "../../context/LoaderContext";
import { Fade } from "react-awesome-reveal";

const Album = (props: { galleryImageData: IGalleryImageData[] }) => {
  const { loading } = useLoader();

  const album = props?.galleryImageData?.map((event) => ({
    ...event,
    attributes: {
      ...event.attributes,
      ...formatDateDetails(event?.attributes?.Date),
    },
  }));
  return (
    // <section className="events-page">
    //   <div className="container">
    //     <div className="row">
    //       {props?.galleryImageData?.map((image) => (
    //         <div className="col-xl-3 col-lg-6 col-md-6">
    //           <div className="events__single">
    //             <div className="events__img">
    //               <img
    //                 src={`${process.env.REACT_APP_strapiUrl}${image?.attributes?.Thumbnail?.data?.attributes?.url}`}
    //                 alt="album-image"
    //                 height="255"
    //               />
    //               {/* <div className="events__date">
    //                     <p>{event?.attributes?.Date}</p>
    //                   </div> */}
    //             </div>
    //             <div className="events__content">
    //               <h3 className="events__title">
    //                 {/* <Link
    //                       to="/events/events-details"
    //                       state={{
    //                         id: event.id,
    //                         bannerUrl: props?.eventBannerImage
    //                       }}
    //                     > */}
    //                 {image?.attributes?.Title}
    //                 {/* </Link> */}
    //               </h3>
    //               {/* <ul className="list-unstyled events__meta"> */}
    //               {/* <li>
    //                       <i className="far fa-clock"></i>
    //                       {event?.attributes?.Time}
    //                     </li>
    //                     <li>
    //                       <i className="fas fa-map-marker-alt"></i>
    //                       {event?.attributes?.Event_Location}
    //                     </li> */}
    //               <div className="custom-newsletter-button">
    //                 <Link
    //                   to="/gallery/gallery-view"
    //                   state={{
    //                     id: image.id,
    //                   }}
    //                   className="donate-btn main-header-two__btn custom-main-header-two__btn"
    //                 >
    //                   View Gallery
    //                 </Link>
    //               </div>
    //               {/* </ul> */}
    //             </div>
    //           </div>
    //         </div>
    //       ))}
    //     </div>
    //   </div>
    // </section>
    <section className="events-page">
      <div className="container">
        <div className="row">
          {!loading &&
            album?.map((image, index) => (
              <div className="col-xl-3 col-lg-6 col-md-6" key={image.id}>
                <Fade
                  key={index}
                  cascade
                  damping={0.2}
                  triggerOnce={true}
                  delay={index * 200}
                >
                  <div className="events__single">
                    <div className="events__img">
                      <img
                        src={`${process.env.REACT_APP_strapiUrl}${image?.attributes?.Thumbnail?.data?.attributes?.url}`}
                        alt="album-image"
                        style={{
                          objectFit: "cover",
                          // height: "200px",
                          height: "255px",
                        }}
                      />
                      <div className="events__date">
                        <p>
                          {image?.attributes?.Date} <br />{" "}
                          {image?.attributes?.Month}
                        </p>
                      </div>
                    </div>
                    <div
                      className="events__content"
                      // style={{ padding: "15px" }}
                    >
                      <h3
                        className="events__title custom-grid-font-size"
                        style={{ marginBottom: "unset" }}
                      >
                        <Link
                          to="/gallery/gallery-view"
                          state={{
                            id: image.id,
                          }}
                        >
                          {image?.attributes?.Title}
                        </Link>
                      </h3>
                    </div>
                  </div>
                </Fade>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Album;
